import { isMobile } from "@common_lib/base/utils/src/tools"
import loadSetting from "@/utils/loadSetting"
import setFontSizeConfig from "@/plugins/fontSizeConfig"
import type { RouteLocationNormalized } from "vue-router"

const templateCssStyle = import.meta.glob("@source/themes/**/*.css", {
  query: "?inline"
})
const isDevelopment = import.meta.env.VITE_DOMAIN_CHANGE === "true"

const calcMobileToDesktopFontSize = () => {
  // const desktopContainer = 1350
  // const mobileContainer = window.screen.width
  // const scale = mobileContainer / desktopContainer

  const rootElement = document.querySelector(":root")! as HTMLElement
  // const fontSize = rootElement.style.fontSize
  //   ? Number(rootElement.style.fontSize.replace("px", ""))
  //   : 16

  // rootElement.style.setProperty("--font-size-base", `${fontSize * scale}`)

  rootElement.style.setProperty("--font-size-base", `${12}`)
}

const appendStyleElement = async (module: { default: string }, id: string) => {
  const style = document.createElement("style")
  style.id = id
  style.textContent = module.default

  document.head.appendChild(style)
}

const removeStyleElement = async (id: string) => {
  const existingStyle = document.querySelector(`style[id='${id}']`)
  if (existingStyle) {
    existingStyle.remove()
  }
}

const findWebsiteSetting = async (websiteName: string) => {
  const uiCSSFileName = websiteName.toLowerCase()
  const forceCSSFileName = isDevelopment && localStorage.getItem("website")
  const fileName = forceCSSFileName || uiCSSFileName

  const setting = await loadSetting()
  const webSiteSetting = setting[fileName]

  if (!webSiteSetting?.themes) {
    throw new Error("Invalid template")
  }

  return webSiteSetting
}

const loadCustomSettingScssWhenMobileToDesktop = async (websiteName: string) => {
  try {
    const webSiteSetting = await findWebsiteSetting(websiteName)
    const themes = webSiteSetting.themes.desktop

    if (themes === undefined) throw new Error("Invalid template")

    const [[, module] = [undefined, undefined]] = Object.entries(templateCssStyle).filter(
      ([path]) => path.includes("desktop") && path.split("/").pop() === `${themes}.css`
    )
    if (module === undefined) throw new Error("Invalid setting themes")

    const loadModule = (await module()) as { default: string }
    await appendStyleElement(loadModule, "desktop-force-custom-theme")
  } catch (error) {
    console.error("Failed to import custom setting:", error)
  }
}

const loadDesktopViewPort = () => {
  const viewport = document.querySelector("meta[name=viewport]") as HTMLMetaElement

  viewport.setAttribute(
    "content",
    "width=device-width, initial-scale=1, viewport-fit=cover, orientation=portrait"
  )
}

const loadMobileViewPort = () => {
  const viewport = document.querySelector("meta[name=viewport]") as HTMLMetaElement

  viewport.setAttribute(
    "content",
    "width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, user-scalable=no, orientation=portrait"
  )
}

const checkStrHasDesktop = (str: string) => /^\/desktop\//.test(str)

export const loadDesktopThemeInMobile = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  websiteName: string
) => {
  if (!isMobile()) return
  const { fetch: fetchQueryEventLabel } = useFetchQueryEventLabel()

  const isMobileToDesktop = !checkStrHasDesktop(from.path) && checkStrHasDesktop(to.path)
  const isDesktopToMobile = checkStrHasDesktop(from.path) && !checkStrHasDesktop(to.path)

  if (isMobileToDesktop) {
    calcMobileToDesktopFontSize()
    const module = await import("@/assets/styles/desktop.scss?inline")

    await removeStyleElement("mobile-custom-theme")
    await appendStyleElement(module, "desktop-custom-theme")
    await loadCustomSettingScssWhenMobileToDesktop(websiteName)
    await fetchQueryEventLabel({ isMobile: false })
    await loadDesktopViewPort()
    return
  }

  if (isDesktopToMobile) {
    setFontSizeConfig()
    const module = await import("@/assets/styles/mobile.scss?inline")

    await removeStyleElement("desktop-custom-theme")
    await removeStyleElement("desktop-force-custom-theme")
    await appendStyleElement(module, "mobile-custom-theme")
    await fetchQueryEventLabel({ isMobile: true })

    await loadMobileViewPort()
  }
}

export default loadDesktopThemeInMobile
